<template>
    <div class="digital-content">
        <div class="digital-marketing">
            <div class="marketing-title">数字化营销领导者</div>
            <div class="marketing-box">
                <div class="marketing-box-item">
                    <div class="marketing-flex">
                        <div class="marketing-big">
                            <span class="marketing-number">95</span>%
                        </div>
                        <div class="marketing-small">
                            千亿房企覆盖率
                        </div>
                    </div>
                </div>
                <div class="marketing-box-item">
                    <div class="marketing-flex">
                        <div class="marketing-big">
                            <span class="marketing-number">80</span>%
                        </div>
                        <div class="marketing-small">
                            复购率
                        </div>
                    </div>
                </div>
                <div class="marketing-box-item">
                    <div class="marketing-flex">
                        <div class="marketing-big">
                            <span class="marketing-number">600</span>+
                        </div>
                        <div class="marketing-small">
                            服务客户
                        </div>
                    </div>
                </div>
                <div class="marketing-box-item">
                    <div class="marketing-flex">
                        <div class="marketing-big">
                            <span class="marketing-number">6,400</span>
                        </div>
                        <div class="marketing-small">
                            覆盖案场数
                        </div>
                </div>
                </div>
                <div class="marketing-box-item">
                    <div class="marketing-flex">
                        <div class="marketing-big">
                            <span class="marketing-number">87</span>%
                        </div>
                        <div class="marketing-small">
                            成交来自营销云
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
  export default {
    name: 'digital-marketing',
    props: {
    },
    data () {
      return {
        activeName: 'first',
      }
    },
    methods: {
      handleClick(tab, event) {
        console.log(tab, event);
      },
    }
  }
</script>
<style lang="scss" scoped>
.digital-content{
background: #F7F9FB;
    .digital-marketing{
        margin: 0 auto;
        width: 1200px;
        padding: 70px 0 80px;
        // height: 718px;
        .marketing-title{
            font-size: 32px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #2D2E30;
            text-align: center;
            margin-bottom: 50px;
        }
        .marketing-box{
            display: flex;
            height: 152px;
            background: linear-gradient(180deg, #F3F5F7 0%, #FFFFFF 100%);
            box-shadow: 0px 4px 12px 0px rgba(155,165,192,0.25), inset 0px 1px 3px 0px rgba(0,0,0,0.03);
            border: 2px solid #FFFFFF;
            .marketing-box-item{
                width: 240px;
                height: 152px;
                text-align: center;
                display: flex;
                justify-content: center;
                align-items: center;
                .marketing-flex{
                    .marketing-big{
                        color: #3777F6;
                        font-size: 14px;
                        .marketing-number{
                            font-size: 32px;
                            font-weight: 600;
                        }
                    }
                    .marketing-small{
                        font-size: 14px;
                        font-family: PingFangSC-Regular, PingFang SC;
                        font-weight: 400;
                        color: #5A5C60;
                        margin-top: 12px;
                    }
                }
            }
        }
    }
}

// 移动端布局
@import "@/views/home/min-home";
</style>
  